import '@fontsource-variable/fraunces';
import './styles.css';
import './i18n';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router/dom';
import { refreshSession } from './lib/account';
import { startBackgroundSync } from './lib/sync';
import { startDataMirror } from './stores/data';
import { router } from './router';

startDataMirror();
startBackgroundSync();
void refreshSession();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
);
